import React from "react";
import {
  Text,
  Input,
  Box,
  Grid,
  HStack,
  Center,
  Divider
} from "@chakra-ui/react";


import { useState, useEffect} from 'react';
import ModalButton from './modalbutton'
import LoadingSkeleton from './loadingSkeleton'
import {CustomTable} from "./customTable";
import { Stat } from "./stats";
import { UserCard } from "./userCardEc2";
import { tableColsMT } from "../data/tableColsMT";
import getData from "../utils/fetchData";
import PostData from "../utils/postData";
import DeleteData from "../utils/deleteData";
import { prepareDataForMTTable } from "../utils/prepareDataForMTTable";



// redefine console.log in order to disable console outputs
//comment out to show console outputs again.

console.log = function(){}

function ReactTableMulti(props) {
    console.log("react table envs")
    console.log(props)
    const API_ENDPOINT= props.env.api_url
    /*
    Main EC2Table component: heart of all functionality
    */
    
    const[instances, setInstances] = useState()
    const[filteredInstances, setFilteredInstances] = useState([])
    const[serverRespRowData, setServerRespRowData] = useState()
    const[adminType, setAdminType]=useState()
    const[currUser, setCurrUser] = useState({"email":"", "admintype": "-1"})
    const path = '/tenants';
    /*
    Child componenent ModalButton uses this function as a callback to send the data to this compoennt

    params:
            duration: duration of turning on the instance
            id: instance Id
            action: start/stop
            email: email address of logged in user to initialise API request
    This data comes from the ModalButton once user puts in the value
    
    */

    const handlePassedData = (duration, startTime, tenantName, action, userData, instance, justification, note) =>{
        let p = ""
        let urlSafeJustStr = encodeURIComponent(justification)
        if(action === "postpone"){
            p = "/tenant/"+ tenantName + "?user=" + userData['email'] +"&action=start" + "&duration=" + duration +  "&justification="+urlSafeJustStr + "&env="+ instance.environment + "&region=" + instance.region + "&ns=" + instance.namespace
        }else{
            p = "/tenant/"+tenantName+"?user=" + userData['email'] +"&action=" + action  + "&duration=" + duration + "&justification="+urlSafeJustStr + "&env="+ instance.environment + "&region=" + instance.region + "&ns=" + instance.namespace
        }
        //console.log(instance)
        let data = {
            tenantName: tenantName,
            region : instance.region,
            az: instance.az,
            env: instance.environment,
            duration: duration,
            startTime: startTime?startTime:"",
            user: userData["email"],
            justification: justification,
            action: action,
            note:note,
            namespace: instance.namespace
        }
    console.log(data)
        // if(duration === 0){
        //     alert("Duration of run can't be zero. Please select a new time.")
        // }
        if(action === "start" || action === "postpone" || action === "schedule"){
            console.log("here we go......")
            PostData(API_ENDPOINT+p, props.user["id_tok"], data )
            .then(response => {
                console.log(response)
                if(action === "postpone"){
                    setServerRespRowData(response.data)
                    alert("Info: The shutdown of the requested instance will be postponed.Please refresh the page to display the change.")   
                }else if (action === "start"){
                    setServerRespRowData(response.data)
                    alert("Info: The requested instance will be started shortly. Please refresh the page to display the change.")
                }else if (action === "schedule"){
                    setServerRespRowData(response.data)
                    alert("Info: The instance has been scheduled to start. Please refresh the page to display the change.")
                }
                else{
                    setServerRespRowData(response.data)
                    alert("Info: Shutdown scheduled. The instance will be shut down in the given time.")
                }
            })
            .catch(error => {
                console.log(error);
                alert(`Error: An error occured while trying to ${action} the instance . Please try again later or contact the Administrator. + error: ${error}`)
            });
        }
        if(action === "stop"){
            
            DeleteData(API_ENDPOINT+p, props.user["id_tok"])
            .then(response => {
                console.log(response)
                setServerRespRowData(response.data)
                alert("Info: The requested instance will be stopped shortly.Please refresh the page to display the change.")
            })
            .catch(error => {
                console.log(error);
                alert(`Error: An error occured while trying to ${action} the instance . Please try again later or contact the Administrator. + error: ${error}`)
            });
        }

    }

    /*
    Convert Unix Epoch time to date time format
    startup and shutdown time are stored as tags of ec2 instacnes in Unix epoch time

    params:
            timeEpoch: Unix Epoch Time
            offset: needed if it needs to be in another time zone. not used here.
    
    */


    const __handleSearch = (event) => {
       console.log(event.target.value)
       var search_results = []
       search_results = instances.filter((ins) =>{
        /*
            since all names are of form prefix.acrolinx.cloud, the search results all instances
            if any letter form the domain name is the first letter of the search
            avoid this problem by first removing the domain part of the name.
            let ins_prefix = ins.tags.Name.split(".")[0]
        */
        let ins_prefix = ins.hostname
        return ins_prefix.includes(event.target.value.toLocaleLowerCase())
       }
     
       );
       console.log(search_results)
       setFilteredInstances(search_results)
    };


    useEffect(() =>{
                console.log(props)
                var res = props.user
                console.log(props.user)
                const url = API_ENDPOINT+path+"?user="+(res['email'])+"&env="+ props.env.env
                getData(url, props.user["id_tok"] )
                .then(response => {
                    console.log(response)
                    let arr = response.data
                    let adminInfo = response.userInfo.admintype
                    console.log("admintype = "+ adminType)
                    setCurrUser(response.userInfo)
                    setAdminType(adminInfo)
                    let preparedInstances = prepareDataForMTTable(arr)
                    setInstances(preparedInstances)
                    setFilteredInstances(preparedInstances)
                    })
                    .catch(error => {
                        console.log(error);
                    });
    //actionInstance refers to the instance on which an action is performed
    // this is set as dependency so the table updates after an action to reflect new state
    },[serverRespRowData])



  const columns = React.useMemo(
    () => [
        /*
        For the table columns which only reppresent information and do not have special
        functinality, e.g., buttons turning on and off, or manipulating UTC time to display
        on local time zone, these can be populated directly on the ../data/tableCols.js file
        We need a Header name and an accessor. Accessor can either be a key name of an element of
        the instances array we get from the API or arbitray if Cell is defined.
        */
          ...tableColsMT,
          {
            Header: "Start/Stop",
            accessor: "actionk",
            Cell: ({row})=>{

                if(row.original.justification !== "Permanently Active")
                {
                return row.original.action!=="start"?(
                    <div>
                        <ModalButton
                            key={"modalButton"+1}
                            buttonColor="blue"
                            buttontitle= "Start"
                            handlePassedData={handlePassedData}
                            description="Start a MT instance"
                            instanceId={row.original.hostname}
                            action={"start"}
                            adminType={adminType}
                            userData={props.auths}
                            // all the info about the instance
                            instance = {row.original}
                            env = {props.env}
                            
                        />
                    </div>
                    ):(
                        <ModalButton
                            key={"modalButton"+2}
                            buttonColor="red" 
                            buttontitle= "Stop"
                            handlePassedData={handlePassedData}
                            description="Stop an instance"
                            instanceId={row.original.hostname}
                            action={"stop"}
                            adminType={adminType}
                            userData={props.auths}
                            env={props.env}
                            // all the info about the instance
                            instance = {row.original}
                        />
                    )
                }
                else{
                    return <Text>  </Text>
                }
            },
            sortType: ((rowA, rowB) => {
                if (rowA.original.state > rowB.original.state) return 1; 
                if (rowB.original.state > rowA.original.state) return -1;
                return 0;
         })
                 
          },
          {
            Header: "Shutdown Time",
            accessor: "shutdownTime",
            },  
          {
            Header: "Postpone",
            accessor: "postpone",
            Cell: ({row})=>{
                if(row.original.justification !== "Permanently Active"){
                return row.original.state !== "stopped"?
                (<ModalButton
                    key={"modalButtonPostpone"+1}
                    buttonColor="blue"
                    buttontitle= "Postpone Shutdown"
                    handlePassedData={handlePassedData}
                    description="Postpone Shutdown"
                    instanceId={row.original.hostname}
                    action={"postpone"}
                    adminType={adminType}
                    userData={props.auths}
                    instance = {row.original}
                    env={props.env}
                    />):
                    <h2>N/A</h2>
                }
                else{
                    return <Text>  </Text>
                }

            },
          }
        ],
    [currUser]
  );
  return(
    <div>
    <div>
    <Grid className="searchAndUserCard" templateColumns='repeat(3, 1fr)' gap={6}>
{     <HStack>
        <Stat data={instances} />
    </HStack>}
    <Center>     
    <Box >
        <Text mb='0px'>Search instances</Text>  
            <Input
                borderColor='black'
                focusBorderColor='crimson'
                placeholder='search'
                onChange={e => __handleSearch(e)} />
        </Box>    
    </Center>     
    <UserCard email={props.user.email} adminTypes={props.auths.adminTypes["sandboxes"]} />       
    </Grid>
    <Divider marginBottom={5} />
    {
        currUser && 
        instances?<CustomTable columns={columns} data={filteredInstances} />:<LoadingSkeleton />
    }
    </div>

  </div>
  )
}

export default ReactTableMulti;

